import { $log, xavis_experiments } from './debug';

const counts: { [kind: string]: number } = {};
const gc_items: { kind: string, name: string, object: WeakRef<object> }[] = [];

function check_gcs() {
    for(let i = 0; i < gc_items.length; ++i) {
        const item = gc_items[i];
        if(!item.object.deref()) {
            gc_items.splice(i, 1);
            counts[item.kind]--;
            $log('gc', '-', item.kind, item.name, counts[item.kind]);
            i--;
        }
    }
}

let is_registered = false;

export function yLifetimeTracked<T extends abstract new (...args: any[]) => {}>(cls: T) {
    if(!xavis_experiments) return;

    const kind = cls.name;

    abstract class Mixin extends cls {
        constructor(...args: any[]) {
            super(...args);

            const name = this.constructor == Mixin ? kind : this.constructor.name;
            gc_items.push({ kind, name, object: new WeakRef(this) });
            counts[kind] = (counts[kind] || 0) + 1;
            $log('gc', '+', kind, name, counts[kind]);

            if(!is_registered) {
                is_registered = true;
                setInterval(check_gcs, 1000);
            }
        }
    }

    return Mixin;
}
